// extracted by mini-css-extract-plugin
export default {"root":"_2yt8t","body-wrapper":"_1qFdN","bodyWrapper":"_1qFdN","big":"_16mV0","postfix":"tGBWq","small":"_3O26g","body-node":"_1tUno","bodyNode":"_1tUno"};